import { ShowSection } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import BusinessOutcomes from './BusinessOutcomes';
import { MILESTONE_STATUS, OUTCOME_STATUS, useProjectDataContext } from 'domain/shared/newProject';
import { BusinessOutcomesType } from './types';
import useOutcomesService from './useOutcomesService';
import { omit } from 'lodash';
import { ProjectOutcomesResponse } from './hooks/useOutcomes';
import { MilestonesType } from '../milestones/types';
import { EditableListFormShowTemplate, NEW_ROW_ID_PREFIX } from 'framework/list';

const BusinessOutcomesContext = ({ data }: { data?: ProjectOutcomesResponse }) => {
  const { businessOutcomesBatch, getOutcomesValidationSchema } = useOutcomesService();
  const { data: projectData } = useProjectDataContext();

  const milestones = data?.milestones.map(
    ({ alias = '', title = '', status = MILESTONE_STATUS.ACTIVE }: MilestonesType) => ({
      alias,
      title,
      status,
    }),
  );

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <FormShowTemplate
        isInitialsLoadingPosition
        submitFormFunc={async values => {
          const itemsToSubmit = values.businessOutcomes
            .filter((item: Record<string, unknown>) => !item['_isMarkedForDeletion'])
            .map((v: BusinessOutcomesType) =>
              omit(
                {
                  ...v,
                  ...(v.id.toString().startsWith(NEW_ROW_ID_PREFIX) && { id: null, status: OUTCOME_STATUS.ACTIVE }),
                },
                '__typename',
              ),
            );

          const savedOutcomes = await businessOutcomesBatch(projectData.id, itemsToSubmit);
          return { businessOutcomes: savedOutcomes };
        }}
        afterSubmit={{
          message: 'You are awesome! The Project outcomes section has been successfully updated.',
        }}
        initialData={data}
        getValidationSchemaFunc={getOutcomesValidationSchema}
      >
        <EditableListFormShowTemplate
          listSource="businessOutcomes"
          localStorageKey={`project:${data?.id}:businessOutcomes`}
        >
          <BusinessOutcomes milestones={milestones} />
        </EditableListFormShowTemplate>
      </FormShowTemplate>
    </ShowSection>
  );
};

export default BusinessOutcomesContext;
